import React, { useState } from 'react';
import SectionTalentHero from './SectionTalentHero/SectionTalentHero';
import { useListingPageContext } from '../context/ListingPageContext';
import css from '../ListingPage.module.css';

function RenderTalent() {
  const { publicData } = useListingPageContext();
  const [selectedService, setSelectedService] = useState(null);
  const providerServices = publicData[selectedService] || [];

  return (
    <div className={css.pageRoot}>
      <SectionTalentHero
        onSelectService={key => setSelectedService(key)}
        providerServices={providerServices}
        selectedService={selectedService}
        isTalentProfileModalContent={true}
      />
    </div>
  );
}

export default RenderTalent;
